import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import ".././../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchDieticiansData } from "../../redux/reducers/apiSlice";
import Diets from "../../components/diet/common/Diets";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import DieticianForm from "../../components/diet/dietician/DieticianForm";
import HelmetWrapper from "../../HelmetWrapper";

const Dieticians = () => {
  const dispatch = useDispatch();
  const { dieticiansData } = useSelector((state) => state.api);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const [modals, setModal] = useState(false);
  const iniDieticianFilters = {
    searchString: "",
  };
  const [dieticianFilters, setDieticianFilters] = useState(iniDieticianFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");

  const iniDieticiansData = {
    isPage: 0,
    pagination: [],
    allDieticiansData: [],
  };
  const [allDieticians, setAllDieticians] = useState(iniDieticiansData);

  const onClickSearch = () => {
    setSearchFilterApplied(true);
    const searchQP = dieticianFilters.searchString
      ? `&search=${dieticianFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  useEffect(() => {
    dispatch(
      fetchDieticiansData({
        pageNo: allDieticians.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allDieticians.isPage]);

  useEffect(() => {
    if (dieticianFilters.searchString?.length === 0) {
      dispatch(
        fetchDieticiansData({
          pageNo: 1,
          limit: 10,
          queryParameters: sendableQPs?.replace(/&?search=[^&]*/, ""),
          token: decryptedText?.token,
        })
      );
      setSearchFilterApplied(false);
    }
  }, [dieticianFilters.searchString]);

  useEffect(() => {
    if (dieticiansData?.status && dieticiansData?.data?.length > 0) {
      const { data, pagination } = dieticiansData || {};

      setAllDieticians({
        ...allDieticians,
        allDieticiansData: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllDieticians({
        ...allDieticians,
        allDieticiansData: [],
        pagination: [],
      });
    }
  }, [dieticiansData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Dietician Management">
      <Container className="bg-cloud-k dietMealsParentContainer px-50px" fluid>
        <Modal
          isOpen={modals}
          onRequestClose={() => {
            setModal(false);
          }}
          contentLabel="Add Dietician Modal"
          ariaHideApp={false}
        >
          <DieticianForm
            decryptedText={decryptedText}
            closeModal={() => setModal(false)}
            callFunction={() =>
              dispatch(
                fetchDieticiansData({
                  pageNo: 1,
                  limit: 10,
                  queryParameters: sendableQPs,
                  token: decryptedText?.token,
                })
              )
            }
          />
        </Modal>

        <Row>
          <Col>
            <MealsStructure text={"All dieticians"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <SearchNButtons
              pageName={"dietician"}
              btnText={"+ Add Dietician"}
              filters={dieticianFilters}
              setFilters={setDieticianFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              onClickAdd={() => setModal(true)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Diets
              name={"dietician"}
              decryptedText={decryptedText}
              allDatas={allDieticians}
              setAllDatas={setAllDieticians}
              callFunction={() =>
                dispatch(
                  fetchDieticiansData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Dieticians;
